import type { StaticContentEntity as StaticContentSchema } from '@core-api/editor/types/response';
import type { QuestionSlideType } from '@mentimeter/legacy-series-types/common';

export const SlideTypeByStaticContentType: Record<
  StaticContentSchema['type'],
  QuestionSlideType
> = {
  'free-text': 'free-text',
  'google-slides': 'google-slides',
  'guess-the-number': 'heading',
  'multiple-choice': 'heading',
  'open-ended': 'heading',
  'pin-on-image': 'heading',
  'questions-from-audience': 'heading',
  'quick-form': 'heading',
  'quiz-choice': 'heading',
  'quiz-open': 'heading',
  'word-cloud': 'heading',
  big: 'big',
  document: 'document',
  heading: 'heading',
  image: 'image',
  instructions: 'instructions',
  leaderboard: 'heading',
  list: 'bullets',
  miro: 'miro',
  number: 'number',
  paragraph: 'paragraph',
  powerpoint: 'powerpoint',
  prioritization: 'heading',
  quote: 'quote',
  ranking: 'heading',
  rating: 'heading',
  scales: 'heading',
  video: 'video',
};

export const staticContentTypeToSlideType = (
  staticContentType: StaticContentSchema['type'],
): QuestionSlideType => {
  return SlideTypeByStaticContentType[staticContentType];
};
